import { render, staticRenderFns } from "./IntercomEditTab.vue?vue&type=template&id=0dc8869c&"
import script from "./IntercomEditTab.vue?vue&type=script&lang=js&"
export * from "./IntercomEditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports